import { FMCardFiftyFifty } from '@own/fds-react';
import '../onboarding-5050-card-overrides.scss';
import { useDyfFdsCardContent } from '../../../../../../views/dyf-landing-view/hooks/use-dyf-fds-cards';
import { useDyfFdsButtonContent } from '../../../../../../views/dyf-landing-view/hooks/use-dyf-fds-buttons';
import { useAemImageRendition } from '../../../../../../hooks/use-aem-image-rendition/use-aem-image-rendition';

export const GVT5050Card = (props: {
    isMobile?: boolean;
    mediaSide: 'left' | 'right';
    baseRoot: string;
    brand: string;
    discoverYourFordText: string;
    onClick: ({
        dyfComponentName,
        categoryName,
    }: {
        dyfComponentName: string;
        categoryName: string;
    }) => void;
}) => {
    const dyfLandingGvtCard = useDyfFdsCardContent('gvt');
    const dyfLandingGvtCardButton = useDyfFdsButtonContent('gvt');

    const optimizedImage = useAemImageRendition({
        src: dyfLandingGvtCard?.mediaSrc ?? '',
        renditionsMap: 'default',
        removeDomain: false,
    });

    return (
        <FMCardFiftyFifty
            headline={dyfLandingGvtCard.title}
            title={props.discoverYourFordText}
            description={dyfLandingGvtCard.body || ''}
            media={{
                src: props.isMobile ? '' : optimizedImage,
                alt: dyfLandingGvtCard.mediaAltText || '',
            }}
            button={{
                type: 'primary',
                label: dyfLandingGvtCardButton.buttonLabel,
                href: `${
                    props.baseRoot
                }/discover-your-${props.brand.toLowerCase()}/scheduling`,
                disabled: false,
                onClick: () =>
                    props.onClick({
                        dyfComponentName: dyfLandingGvtCard.title,
                        categoryName: dyfLandingGvtCardButton?.buttonLabel,
                    }),
                theme: 'light',
            }}
            mediaSide={props.mediaSide}
            imageLoading="eager"
            imageFetchPriority="high"
            imageDecoding="async"
            imageStyles={{
                width: '100%',
                height: '100%',
                aspectRatio: '1/1',
            }}
        />
    );
};
